module.exports = __webpack_public_path__ + "img/ic-select-down-blue.b463c724.svg";